module.exports = __webpack_public_path__ + "files/222086076291d19e40d81a101d3a653d.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people-7.png
// module id = 1371
// module chunks = 59